import { FC, memo } from 'react';
import { useSpring, animated } from '@react-spring/web';
import styles from './index.module.scss';
import { getAssetUrl } from '@/utils/common';

interface Props {
  type?: string;
  index: number;
  item: any;
}

const PoetryCard: FC<Props> = ({ item, index, type }) => {

  const spring = useSpring({
    from: { scale: 0, opacity: 0 },
    to: { scale: 1, opacity: 1 },
    delay: index * 50,
    config: {
      tension: 180 * 2,
      friction: 12,
    }
  });


  return (
    <animated.div
      className={styles.content_poetry}
      style={{
        left: item.position?.left > -1 ? item.position?.left : '',
        top: item.position.top,
        right: item.position?.right > -1 ?  item.position?.right : '',
        ...spring
      }}
    >
      <p className={styles.titles}>
        <span className={styles.circle_icon}>
          <img src={getAssetUrl('images/landmark/circleIcon.svg')} alt="" />
        </span>
        <span>{type ? item.name : item.vertex.name}</span>
      </p>
      <p className={styles.author}>{type ? item.dynasty : item.vertex.dynasty}·{type ? item?.author?.[0] : item.vertex.author?.[0]}</p>
      <div className={styles.verse}>
        {type ? item.summary : item.vertex.summary}
      </div>
    </animated.div>
  )
}

export default memo(PoetryCard);
